/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Badge, Collapse } from 'react-bootstrap'
import Tappable from 'react-tappable'
import classNames from 'classnames'
import Big from 'big.js'
import Image from 'components/image'
import { track, tracking } from 'lib/analytics'
import pluralize from 'pluralize'

import * as BLConstants from 'shared/constants'
import * as urls from 'lib/urls'
import { numberToCurrency } from 'lib/money'
import { Price } from 'shared/offer'
import { InfoButton } from 'components/buttons'

import * as api from 'cart/api'
import {
  buildCartItems,
  getRegistryDiscountSubtotal,
  getStores,
  getSubTotal,
  getTotalQuantity,
} from 'cart/lib'
import { RegistryDiscount } from 'cart/components/store-order-summary'
import EmptyCart from 'cart/components/empty-cart'

import css from './cart-summary.scss'

export const NUM_PREVIEW_ITEMS = 3

@tracking()
class CartSummary extends Component {
  constructor(props) {
    super(props)
    const useRegistryDiscount =
      props.cart.isEligibleForRegistryDiscount &&
      props.cart.applyRegistryDiscount
    this.state = {
      amazonCart: {},
      cart: {},
      items: buildCartItems(
        null,
        props.cart,
        props.reservations,
        null,
        useRegistryDiscount
      ),
      reservations: props.reservations,
      showCartDropdown: props.showCartDropdown || false,
      showEstTotalHint: false,
      useRegistryDiscount,
    }
    this.hideCartDropDownTimeoutId = null
    this.handleHideCartDropdown = this.handleHideCartDropdown.bind(this)
    this.handleShowCartDropdown = this.handleShowCartDropdown.bind(this)
    this.handleToggleShowEstTotalHint =
      this.handleToggleShowEstTotalHint.bind(this)
  }

  componentDidMount() {
    const { cart } = this.props
    this.fetchCart()
    PubSub.subscribe(BLConstants.UPDATE_CART_SUMMARY, (data) => {
      api.getCart().then((resp) => {
        const useRegistryDiscount =
          cart.isEligibleForRegistryDiscount && resp.cart.applyRegistryDiscount
        this.setState({
          amazonCart: resp.amazonCart,
          cart: resp.cart,
          items: buildCartItems(
            resp.amazonCart,
            resp.cart,
            resp.reservations,
            null,
            useRegistryDiscount
          ),
          reservations: resp.reservations,
          animateBadge: data && data.animateBadge,
          showCartDropdown: data && data.showCartDropdown,
          useRegistryDiscount,
        })

        this.autoHideTimeoutId = setTimeout(() => {
          this.setState({ showCartDropdown: false, animateBadge: false })
        }, 3000)
      })
    })
  }

  componentWillUnmount() {
    clearTimeout(this.hideCartDropDownTimeoutId)
    clearTimeout(this.autoHideTimeoutId)
  }

  handleHideCartDropdown() {
    this.hideCartDropDownTimeoutId = setTimeout(() => {
      this.setState({ showCartDropdown: false, showEstTotalHint: false })
    }, 500)
  }

  handleShowCartDropdown() {
    // Cancel the existing hide timers whenever the user hovers back over the component,
    // so that hiding the dropdown is less sensitive to mouse movements b/w the header
    // and the dropdown
    clearTimeout(this.hideCartDropDownTimeoutId)
    clearTimeout(this.autoHideTimeoutId)
    this.setState({ showCartDropdown: true })
  }

  handleToggleShowEstTotalHint() {
    const { showEstTotalHint } = this.state
    this.setState({ showEstTotalHint: !showEstTotalHint })
  }

  getReservationsPath() {
    const { registryUrlSlug } = this.props
    const { reservations } = this.state

    let path = reservations.length
      ? urls.reservationPath(reservations[0].token)
      : urls.reservationsPath
    if (registryUrlSlug) {
      path = `${path}?registry=${registryUrlSlug}`
    }
    return path
  }

  fetchCart = () => {
    api.getCart().then((resp) => {
      const { cart } = this.props
      const useRegistryDiscount =
        cart.isEligibleForRegistryDiscount && resp.cart.applyRegistryDiscount
      this.setState({
        amazonCart: resp.amazonCart,
        cart: resp.cart,
        items: buildCartItems(
          resp.amazonCart,
          resp.cart,
          resp.reservations,
          null,
          useRegistryDiscount
        ),
        reservations: resp.reservations,
        animateBadge: false,
        showCartDropdown: false,
        useRegistryDiscount,
      })
    })
  }

  @tracking((props, state, [eventCta]) => ({
    event: track.cartOpened,
    eventCta,
    cartItems: state.items,
  }))
  trackCartOpened(e) {
    //
  }

  renderPreviewItems(totalQuantity, storeCount) {
    const { items, useRegistryDiscount, showEstTotalHint } = this.state
    const registryDiscount = useRegistryDiscount
      ? getRegistryDiscountSubtotal(items)
      : Big(0)
    const subTotal = getSubTotal(items)

    const previewItems = []

    if (items.length) {
      const listHeader =
        totalQuantity > 1
          ? `Your Cart - ${totalQuantity} Items
            ${storeCount > 1 ? ` From ${storeCount} Stores` : ''}`
          : 'Your Cart'

      previewItems.push(
        <li key="item-header" className="phm">
          <div className={css.dropdownHeader}>{listHeader}</div>
        </li>
      )

      previewItems.push(
        <li key="item-header-separator">
          <hr className="mam" />
        </li>
      )

      items.slice(0, NUM_PREVIEW_ITEMS).forEach((item, index) => {
        if (index) {
          previewItems.push(
            <li key={`item-separator-${item.productId || item.uuid}`}>
              <hr className="mam" />
            </li>
          )
        }

        previewItems.push(
          <li className="pam" key={`item-${item.productId || item.uuid}`}>
            <div className="cart-item" style={{ display: 'flex' }}>
              <div className="prl">
                <Image
                  height={100}
                  src={item.imageUrl}
                  role="presentation"
                  width={100}
                />
              </div>
              <div>
                <ul style={{ maxWidth: '160px' }} className="list-unstyled">
                  <li className="mbs">
                    <div className="h6 mvn">{item.name}</div>
                  </li>
                  {item.price || item.quantity > 1 ? (
                    <li>
                      <div className="offer-layout-wrapper">
                        {item.isPurchasableOnBabylist ? (
                          <span className="icon-offer icon-offer-babylist mrs" />
                        ) : null}
                        {item.type ===
                          BLConstants.CONFIG.cart.typeAmazonCart && (
                          <span className="icon-offer icon-offer-amazon mrs" />
                        )}
                        <span className="mvn offer-price offer-price-without-store">
                          {item.price && (
                            <Price
                              className="text-bold"
                              discountedPrice={item.registryDiscountPrice}
                              discountedPriceFirst
                              price={item.price}
                            />
                          )}
                          {item.price && item.quantity > 1 ? ' ' : null}
                          {item.quantity > 1 ? `x ${item.quantity}` : null}
                        </span>
                      </div>
                    </li>
                  ) : null}
                </ul>
              </div>
            </div>
          </li>
        )
      })

      if (items.length > NUM_PREVIEW_ITEMS) {
        previewItems.push(<hr className="mam" key="view-more-separator" />)
        previewItems.push(
          <li className="pam text-center" key="view-more-item">
            <div>
              <a
                className="more pan"
                href={this.getReservationsPath()}
                onClick={this.trackCartOpened.bind(this, 'More')}
              >
                <div className="h6 man">{`+${
                  items.length - NUM_PREVIEW_ITEMS
                } More ${pluralize(
                  'Item',
                  items.length - NUM_PREVIEW_ITEMS
                )}`}</div>
              </a>
            </div>
          </li>
        )
      }

      previewItems.push(
        <li key="est-total-separator">
          <hr className="mvm" />
        </li>
      )

      if (useRegistryDiscount && registryDiscount > 0) {
        previewItems.push(
          <li className="phm ptm text-center" key="registry-discount-item">
            <RegistryDiscount
              amount={registryDiscount}
              className="mvn text-left"
            />
          </li>
        )
      }

      previewItems.push(
        <li className="pam" key="est-total-item">
          <div>
            <a
              className="inline-block pan"
              onClick={this.handleToggleShowEstTotalHint}
            >
              <div className="h6 man">Estimated Total</div>
            </a>
            <div className="h6 mvn pull-right">
              <strong>{numberToCurrency(subTotal - registryDiscount)}</strong>
            </div>
          </div>
          <Collapse in={showEstTotalHint}>
            <div>
              <p className="h7 ptm">
                Prices vary by store, and do not include applicable tax or
                shipping.
              </p>
            </div>
          </Collapse>
        </li>
      )
    } else {
      previewItems.push(
        <li className="pam mtl" key="empty-cart-item">
          <EmptyCart />
        </li>
      )
    }

    previewItems.push(
      <li className="pam" key="view-all-item">
        <div>
          <InfoButton
            className="mhn"
            href={this.getReservationsPath()}
            block
            pill
            onClick={this.trackCartOpened.bind(this, 'Continue to Cart')}
          >
            Continue to Cart
          </InfoButton>
        </div>
      </li>
    )

    return previewItems
  }

  render() {
    const { disableDropdown } = this.props
    const { amazonCart, animateBadge, cart, reservations, showCartDropdown } =
      this.state

    const badgeCount = getTotalQuantity(reservations, cart, amazonCart)
    const storeCount = getStores(reservations).length

    return (
      <div
        onMouseLeave={this.handleHideCartDropdown}
        onMouseOver={this.handleShowCartDropdown}
        onFocus={this.handleShowCartDropdown}
      >
        <Tappable classes={{ active: css.buttonActive }}>
          <a
            className="dropdown-toggle"
            href={this.getReservationsPath()}
            onClick={this.trackCartOpened.bind(this, 'Button')}
            rel="nofollow"
            aria-label="cart"
          >
            <div>
              <span className={css.cartIcon} />
              {badgeCount > 0 && (
                <Badge
                  className={classNames('cart-badge', css.itemsCountBadge, {
                    bounce: animateBadge,
                  })}
                >
                  {badgeCount}
                </Badge>
              )}
            </div>
          </a>
        </Tappable>
        {!disableDropdown && showCartDropdown ? (
          <ul
            className={classNames(
              'animated animate-250ms dropdown-menu fadeIn hidden-xs',
              css.dropdownMenu
            )}
          >
            {this.renderPreviewItems(badgeCount, storeCount)}
          </ul>
        ) : null}
      </div>
    )
  }
}

CartSummary.propTypes = {
  cart: PropTypes.object.isRequired,
  disableDropdown: PropTypes.bool,
  registryUrlSlug: PropTypes.string,
  reservations: PropTypes.array.isRequired,
  showCartDropdown: PropTypes.bool,
}

CartSummary.defaultProps = {
  disableDropdown: false,
  registryUrlSlug: null,
  showCartDropdown: false,
}

export default CartSummary
